import React from 'react';
import { arrayOf, func, number, shape } from 'prop-types';

// Utils
import { formatVolume } from 'utils/helpers/format';

// Components
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { MDropdown } from 'common';
import * as styles from '../ConfirmSubscriptionCard.styles';

const DetailsSection = props => {
  const { affiliateList, overageRate, tierRate, tierVolume, setData, selectedAffiliate } = props;
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });

  // Using reduce because we need to first filter the affiliates
  // based on dataCompanyId (must be 1) then we need to map
  // back the filtered list as a new object
  // Fix as part of CASREF-2981
  const affiliateOptions = affiliateList.reduce(
    (res, affiliate) =>
      affiliate.dataCompanyId === 1
        ? res.concat({ label: affiliate.nameShort, value: affiliate.nameShort })
        : res,
    []
  );

  const handleChange = val => {
    const found = affiliateList.find(({ nameShort }) => nameShort === val);
    setData(prevData => ({ ...prevData, selectedAffiliate: found }));
  };

  return (
    <Box display={mdUp ? 'flex' : 'unset'} justifyContent={mdUp ? 'space-between' : 'unset'} mb={4}>
      <Box width={mdUp ? 230 : '100%'}>
        {mdUp && (
          <Typography sx={{ color: 'text.primary', mb: 1 }} variant="subtitle1">
            Bill to Company
          </Typography>
        )}
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="affiliate-select"
          items={affiliateOptions}
          label="Affiliate"
          name="affiliate"
          onChange={({ value }) => handleChange(value)}
          value={selectedAffiliate?.nameShort}
        />
        {!selectedAffiliate?.nameShort && (
          <Typography sx={styles.helperTextStyles}>Select a Bill to Company</Typography>
        )}
      </Box>
      <Box mb={!mdUp ? 4 : 0} width={mdUp ? 316 : '100%'}>
        <Typography
          sx={{
            color: 'text.primary',
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            mb: { xs: 2, md: 1 },
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            mt: { xs: 3, md: 'initial' },
          }}
          variant={`${mdUp ? 'subtitle1' : 'body1'}`}
        >
          Swift+ Details
        </Typography>
        <>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body2">Volume</Typography>
            <Typography sx={{ color: 'text.primary' }} variant="subtitle1">
              {`${formatVolume(tierVolume)} bbls`}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body2">Volume Rate</Typography>
            <Typography sx={{ color: 'text.primary' }} variant="subtitle1">
              {`$${tierRate}`}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2">Overage Rate</Typography>
            <Typography sx={{ color: 'text.primary' }} variant="subtitle1">
              {overageRate === 0 ? '$0.000' : `$${overageRate}`}
            </Typography>
          </Box>
        </>
      </Box>
    </Box>
  );
};

DetailsSection.propTypes = {
  affiliateList: arrayOf(shape({})).isRequired,
  overageRate: number.isRequired,
  selectedAffiliate: shape({}).isRequired,
  setData: func.isRequired,
  tierRate: number.isRequired,
  tierVolume: number.isRequired,
};

export default DetailsSection;
